var _linearGradient, _path, _path2, _path3, _path4, _linearGradient2, _path5, _linearGradient3, _path6, _path7, _linearGradient4, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _circle4, _circle5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _linearGradient5, _path25, _linearGradient6, _path26, _linearGradient7, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppPromotion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 222.238,
    y1: 704.122,
    x2: 284.238,
    y2: 895.455,
    gradientTransform: "translate(0 -566)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.9 127.8c-22.4-56.9-91.2-91-149.6-68.4-68.6 26.5-43.3 131.2-105 153.1-32.7 11.6-81-31.6-114-38.3-60.8-12.3-115.8 30.6-129.4 90.1-13.8 60.6 8.4 141.6 75 158.1 79.3 19.6 120.7-51.7 187.2-72.2 68.3-21 144.3 28.6 200.8-31.8 41.8-44.7 57.1-134.3 35-190.6z",
    opacity: 0.25,
    fill: "url(#app-promotion_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M431.6 143.4c0-38.8-31.1-70.4-69.8-71.1v-6c0-11.6-9.4-21-21-21H135.2c-11.6 0-21 9.4-21 21V226c-35 4.4-62.1 34.3-62.1 70.5s27.1 66.1 62.1 70.5v101.6c0 11.6 9.4 21 21 21h205.6c11.6 0 21-9.4 21-21V214.5c38.7-.7 69.8-32.3 69.8-71.1zm9.6 242.2l-24.5-25.9c-2-2.1-5.3-2.1-7.3 0L385 385.6c-3 3.2-.8 8.4 3.6 8.4h12.1v38.3c0 2.8 2.2 5 5 5h14.7c2.8 0 5-2.2 5-5V394h12.1c4.4 0 6.7-5.2 3.7-8.4z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3 210c2.8 0 5-2.2 5-5v-38.3h12.1c4.4 0 6.7-5.2 3.6-8.4l-24.5-25.9c-2-2.1-5.3-2.1-7.3 0l-24.5 25.9c-3 3.2-.8 8.4 3.6 8.4h12.1V205c0 2.8 2.2 5 5 5h14.9z",
    opacity: 0.11,
    fill: "#2626bc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2deff",
    d: "M152.1 332.5h209.7v86.8H152.1z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 111.023,
    y1: 249.5,
    x2: 480.178,
    y2: 249.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M358.8 27.3H153.2c-11.6 0-21 9.4-21 21v402.4c0 11.6 9.4 21 21 21h205.6c11.6 0 21-9.4 21-21V48.3c0-11.6-9.4-21-21-21zM172.4 398.1c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-7.8c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v7.8zm22.6 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-7.8c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v7.8zm22.6 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-7.8c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v7.8zm22.6 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-7.8c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v7.8zm22.7 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-18.7c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v18.7zm22.6 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-25.9c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v25.9zm22.6 0c0 2-1.6 3.6-3.6 3.6H298c-2 0-3.6-1.6-3.6-3.6v-18.7c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v18.7zm22.6 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-36.8c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v36.8zm22.7 0c0 2-1.6 3.6-3.6 3.6h-6.5c-2 0-3.6-1.6-3.6-3.6v-54.9c0-2 1.6-3.6 3.6-3.6h6.5c2 0 3.6 1.6 3.6 3.6v54.9z",
    fill: "url(#app-promotion_svg__b)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__c",
    gradientUnits: "userSpaceOnUse",
    x1: 307.4,
    y1: 371,
    x2: 379.8,
    y2: 371,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.8 71.9v142.2h-1.3c-39.3 0-71.1-31.8-71.1-71.1s31.8-71.1 71.1-71.1h1.3z",
    fill: "url(#app-promotion_svg__c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M212.3 296.2c0 39.3-31.8 71.1-71.1 71.1-3.1 0-6.1-.2-9-.6v-141c3-.4 6-.6 9-.6 39.3 0 71.1 31.8 71.1 71.1z",
    fill: "#02ffb3"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__d",
    gradientUnits: "userSpaceOnUse",
    x1: 169.7,
    y1: 338.05,
    x2: 339.9,
    y2: 338.05,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0575e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f260"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M339.9 142.5v66.9c0 2.8-2.2 5-5 5H174.7c-2.8 0-5-2.2-5-5v-66.9c0-2.8 2.2-5 5-5h160.2c2.8 0 5 2.3 5 5z",
    fill: "url(#app-promotion_svg__d)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M339.9 142.5v60.3c-19.6-12.7-32.5-34.7-32.5-59.8 0-1.9.1-3.7.2-5.5h27.3c2.8 0 5 2.3 5 5z",
    opacity: 0.56,
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M379.8 81.5V48.3c0-11.6-9.4-21-21-21H153.2c-11.6 0-21 9.4-21 21v33.2h247.6z",
    fill: "#94b5dd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M379.8 48.3v33.2h-21.9V48.3c0-11.6-9.4-21-21-21h21.9c11.6 0 21 9.4 21 21z",
    fill: "#8399fe"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.8,
    cy: 55.5,
    r: 5.6,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 186.7,
    cy: 55.5,
    r: 5.6,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 206.7,
    cy: 55.5,
    r: 5.6,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 378.5,
    cy: 125.4,
    r: 71.1,
    fill: "#ffd18d"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.2,
    cy: 278.6,
    r: 71.1,
    fill: "#ffd18d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M403 367.6l24.5-25.9c2-2.1 5.3-2.1 7.3 0l24.5 25.9c3 3.2.8 8.4-3.6 8.4h-12.1v38.3c0 2.8-2.2 5-5 5h-14.7c-2.8 0-5-2.2-5-5V376h-12.1c-4.6 0-6.8-5.2-3.8-8.4zM52.8 140.3l24.5-25.9c2-2.1 5.3-2.1 7.3 0l24.5 25.9c3 3.2.8 8.4-3.6 8.4H93.3V187c0 2.8-2.2 5-5 5H73.6c-2.8 0-5-2.2-5-5v-38.3H56.5c-4.4 0-6.7-5.2-3.7-8.4z",
    fill: "#ffaf10"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.8 142.5h-16.7c-2.8 0-5-2.2-5-5s2.2-5 5-5h16.7c2.8 0 5 2.2 5 5s-2.2 5-5 5zm35.1 31.3h-51.8c-2.8 0-5-2.2-5-5s2.2-5 5-5h51.8c2.8 0 5 2.2 5 5s-2.2 5-5 5zm24.8 16.8h-76.5c-2.8 0-5-2.2-5-5s2.2-5 5-5h76.5c2.8 0 5 2.2 5 5s-2.3 5-5 5z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6 104.9c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.7 5.7-5.7 15-5.7 20.7 0 2.8 2.8 4.3 6.4 4.3 10.3s-1.5 7.6-4.3 10.3c-2.9 2.9-6.7 4.4-10.4 4.4zm0-19.2c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5s4.7 1.8 6.5 0c.9-.9 1.3-2 1.3-3.3 0-1.2-.5-2.4-1.3-3.3-.9-.8-2-1.2-3.2-1.2zm414.3 201.4c-3.7 0-7.5-1.4-10.3-4.3-5.7-5.7-5.7-15 0-20.7s15-5.7 20.7 0 5.7 15 0 20.7c-2.9 2.9-6.6 4.3-10.4 4.3zm6.8-7.8zm-6.8-11.4c-1.2 0-2.4.4-3.3 1.3-1.8 1.8-1.8 4.7 0 6.5s4.7 1.8 6.5 0 1.8-4.7 0-6.5c-.8-.8-2-1.3-3.2-1.3z",
    fill: "#8399fe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 464.3c-3.7 0-7.5-1.4-10.3-4.3-2.8-2.8-4.3-6.4-4.3-10.3s1.5-7.6 4.3-10.3c2.8-2.8 6.4-4.3 10.3-4.3s7.6 1.5 10.3 4.3 4.3 6.4 4.3 10.3-1.5 7.6-4.3 10.3c-2.8 2.9-6.6 4.3-10.3 4.3zm0-19.2c-1.2 0-2.4.5-3.3 1.3-.9.9-1.3 2-1.3 3.3s.5 2.4 1.3 3.3c1.8 1.8 4.7 1.8 6.5 0 .9-.9 1.3-2 1.3-3.3s-.5-2.4-1.3-3.3c-.8-.8-2-1.3-3.2-1.3zM91 50.1h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3H91c2.8 0 5-2.2 5-5s-2.3-5-5-5z",
    fill: "#ff7eb8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M485.4 333.4h-3.3v-3.3c0-2.8-2.2-5-5-5s-5 2.2-5 5v3.3h-3.3c-2.8 0-5 2.2-5 5s2.2 5 5 5h3.3v3.3c0 2.8 2.2 5 5 5s5-2.2 5-5v-3.3h3.3c2.8 0 5-2.2 5-5s-2.2-5-5-5z",
    fill: "#01eca5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M378.5 179.3c-29.7 0-53.9-24.2-53.9-53.9s24.2-53.9 53.9-53.9 53.9 24.2 53.9 53.9-24.2 53.9-53.9 53.9zm0-97.8c-24.2 0-43.9 19.7-43.9 43.9s19.7 43.9 43.9 43.9 43.9-19.7 43.9-43.9-19.7-43.9-43.9-43.9z",
    fill: "#ffaf10"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M384.7 120.4h-1.2v-9.3h6c2.8 0 5-2.2 5-5s-2.2-5-5-5h-6v-2.2c0-2.8-2.2-5-5-5s-5 2.2-5 5v2.2h-1.2c-8.1 0-14.7 6.6-14.7 14.7s6.6 14.7 14.7 14.7h1.2v9.3h-6c-2.8 0-5 2.2-5 5s2.2 5 5 5h6v2.2c0 2.8 2.2 5 5 5s5-2.2 5-5v-2.2h1.2c8.1 0 14.7-6.6 14.7-14.7s-6.6-14.7-14.7-14.7zm-12.5 0c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7h1.2v9.3l-1.2.1zm12.5 19.3h-1.2v-9.3h1.2c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.6-4.7 4.6z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 332.5c-29.7 0-53.9-24.2-53.9-53.9s24.2-53.9 53.9-53.9 53.9 24.2 53.9 53.9-24.2 53.9-53.9 53.9zm0-97.8c-24.2 0-43.9 19.7-43.9 43.9s19.7 43.9 43.9 43.9 43.9-19.7 43.9-43.9-19.7-43.9-43.9-43.9z",
    fill: "#ffaf10"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M147.5 273.6h-1.2v-9.3h6c2.8 0 5-2.2 5-5s-2.2-5-5-5h-6V252c0-2.8-2.2-5-5-5s-5 2.2-5 5v2.2H135c-8.1 0-14.7 6.6-14.7 14.7s6.6 14.7 14.7 14.7h1.2v9.3h-6c-2.8 0-5 2.2-5 5s2.2 5 5 5h6v2.2c0 2.8 2.2 5 5 5s5-2.2 5-5v-2.2h1.2c8.1 0 14.7-6.6 14.7-14.7s-6.6-14.6-14.6-14.6zm-12.5 0c-2.6 0-4.7-2.1-4.7-4.7s2.1-4.7 4.7-4.7h1.2v9.3H135v.1zm12.5 19.3h-1.2v-9.3h1.2c2.6 0 4.7 2.1 4.7 4.7-.1 2.5-2.2 4.6-4.7 4.6z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256 442.8c1.3 0 2.6-.5 3.5-1.5l5.8-5.8c2-2 1.9-5.1 0-7.1-2-2-5.1-1.9-7.1 0l-2.3 2.3-2.3-2.3c-2-2-5.1-2-7.1 0s-2 5.1 0 7.1l5.8 5.8c1.1 1 2.4 1.5 3.7 1.5z",
    fill: "#0046c1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M420.9 188.6c2.3-1.5 2.9-4.6 1.4-6.9-1.5-2.3-4.6-2.9-6.9-1.4-10.9 7.3-23.6 11.2-36.8 11.2-36.5 0-66.1-29.7-66.1-66.1s29.7-66.1 66.1-66.1c36.5 0 66.1 29.7 66.1 66.1 0 13-3.8 25.5-10.9 36.4-1.5 2.3-.9 5.4 1.4 6.9s5.4.9 6.9-1.4c8.2-12.4 12.6-26.9 12.6-41.9 0-39.8-30.8-72.6-69.8-75.8v-1.3c0-14.3-11.7-26-26-26H153.2c-14.3 0-26 11.7-26 26v76.2c0 2.8 2.2 5 5 5s5-2.2 5-5v-38h175.9c-6.8 11.4-10.7 24.7-10.7 38.9 0 40.7 32.2 74.1 72.4 76v249.3c0 8.8-7.2 16-16 16H153.2c-8.8 0-16-7.2-16-16v-96.1c1.3.1 2.7.1 4 .1 42 0 76.1-34.1 76.1-76.1s-34.1-76.1-76.1-76.1c-1.4 0-2.7 0-4 .1v-50c0-2.8-2.2-5-5-5s-5 2.2-5 5v51.2c-35.3 6.6-62.1 37.6-62.1 74.8s26.8 68.2 62.1 74.8v97.3c0 14.3 11.7 26 26 26h205.6c14.3 0 26-11.7 26-26V201.3c12.9-1.1 25.3-5.4 36.1-12.7zM137.2 76.5V48.3c0-8.8 7.2-16 16-16h205.6c8.8 0 16 7.2 16 16v1.1c-21.9 1-41.4 11.4-54.6 27.1h-183zM75.1 278.6c0-36.5 29.7-66.1 66.1-66.1s66.1 29.7 66.1 66.1-29.7 66.1-66.1 66.1-66.1-29.7-66.1-66.1z",
    fill: "#0046c1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M462.8 364.2l-24.5-25.9c-1.9-2-4.5-3.1-7.3-3.1s-5.4 1.1-7.3 3.1l-24.5 25.9c-2.7 2.9-3.5 7.2-1.9 10.8 1.6 3.7 5.2 6 9.2 6h7.1v33.3c0 5.5 4.5 10 10 10h14.7c5.5 0 10-4.5 10-10V381h7.1c4 0 7.6-2.4 9.2-6 1.7-3.7.9-7.9-1.8-10.8zm-19.4 6.8c-2.8 0-5 2.2-5 5v38.3h-14.7V376c0-2.8-2.2-5-5-5h-12.1l24.5-25.9 24.5 25.9h-12.2zM73.6 197h14.7c5.5 0 10-4.5 10-10v-33.3h7.1c4 0 7.6-2.4 9.2-6 1.6-3.7.8-7.9-1.9-10.8L88.2 111c-1.9-2-4.5-3.1-7.3-3.1-2.7 0-5.4 1.1-7.3 3.1l-24.5 25.9c-2.7 2.9-3.5 7.2-1.9 10.8 1.6 3.7 5.2 6 9.2 6h7.1V187c.1 5.5 4.6 10 10.1 10zm-17.1-53.3L81 117.8l24.5 25.9H93.3c-2.8 0-5 2.2-5 5V187H73.6v-38.3c0-2.8-2.2-5-5-5H56.5z",
    fill: "#0046c1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M286.3 137.5c0-9.2-7.5-16.6-16.6-16.6s-16.6 7.5-16.6 16.6c0 4.5 1.8 8.6 4.8 11.6-2.9 3-4.8 7.1-4.8 11.6 0 2.8 2.2 5 5 5s5-2.2 5-5c0-3.6 3-6.6 6.6-6.6s6.6 3 6.6 6.6c0 2.8 2.2 5 5 5s5-2.2 5-5c0-4.5-1.8-8.6-4.8-11.6 3-2.9 4.8-7 4.8-11.6zm-16.6-6.6c3.6 0 6.6 3 6.6 6.6s-3 6.6-6.6 6.6-6.6-3-6.6-6.6 3-6.6 6.6-6.6z",
    fill: "#94b5dd"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__e",
    gradientUnits: "userSpaceOnUse",
    x1: 201.318,
    y1: 276.05,
    x2: 475.944,
    y2: 276.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffaf10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    stopColor: "#ffd18d"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M422.6 306.1c-2 2-5.1 2-7.1 0L387.4 278H368c-4 0-7.8-1.6-10.6-4.4L338.8 255c-1-.9-2.2-1.5-3.5-1.5h-24.7c-1.3 0-2.6.5-3.5 1.5l-49.2 49.2c-2.8 2.8-6.6 4.4-10.6 4.4h-36.1c1.4-3.2 2.6-6.6 3.5-10h32.6c1.3 0 2.6-.5 3.5-1.5l49.2-49.2c2.8-2.8 6.6-4.4 10.6-4.4h24.7c4 0 7.8 1.6 10.6 4.4l18.6 18.6c1 1 2.2 1.5 3.5 1.5h21.5c1.3 0 2.6.5 3.5 1.5l29.6 29.6c2 1.9 2 5.1 0 7z",
    fill: "url(#app-promotion_svg__e)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__f",
    gradientUnits: "userSpaceOnUse",
    x1: 217.3,
    y1: 242.137,
    x2: 445.7,
    y2: 242.137
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0046c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02b4a3"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M444.2 209l-29.6 29.6c-2.8 2.8-6.6 4.4-10.6 4.4h-67.2c-1.3 0-2.6.5-3.5 1.5l-15.7 15.7c-2.8 2.8-6.6 4.4-10.6 4.4h-38.2c-1.3 0-2.6.5-3.5 1.5L252 279.4c-2.8 2.8-6.6 4.4-10.6 4.4h-24.1c.1-1.7.2-3.4.2-5.1 0-1.6-.1-3.3-.2-4.9h24.1c1.3 0 2.6-.5 3.5-1.5l13.3-13.3c2.8-2.8 6.6-4.4 10.6-4.4H307c1.3 0 2.6-.5 3.5-1.5l15.7-15.7c2.8-2.8 6.6-4.4 10.6-4.4H404c1.3 0 2.6-.5 3.5-1.5l29.6-29.6c2-1.9 5.1-1.9 7.1 0 2 2 2 5.1 0 7.1z",
    fill: "url(#app-promotion_svg__f)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "app-promotion_svg__g",
    gradientUnits: "userSpaceOnUse",
    x1: 195,
    y1: 286.85,
    x2: 444.613,
    y2: 286.85
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#0046c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02b4a3"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M443.2 249.9l-44.5 44.5c-2.8 2.8-6.6 4.4-10.6 4.4H344c-1.3 0-2.6.5-3.5 1.5L328 312.7c-2.8 2.8-6.6 4.4-10.6 4.4h-46.5c-1.3 0-2.6.5-3.5 1.5l-9.5 9.5c-2.8 2.8-6.6 4.4-10.6 4.4H195c3.1-3.1 5.9-6.4 8.4-10h43.8c1.3 0 2.6-.5 3.5-1.5l9.5-9.5c2.8-2.8 6.6-4.4 10.6-4.4h46.5c1.3 0 2.6-.5 3.5-1.5l12.5-12.5c2.8-2.8 6.6-4.4 10.6-4.4H388c1.3 0 2.6-.5 3.5-1.5l44.5-44.5c2-2 5.1-2 7.1 0s2 5.2.1 7.2z",
    fill: "url(#app-promotion_svg__g)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppPromotion);
export default __webpack_public_path__ + "static/media/app-promotion.677b4e4e7c98a0b459e55b63be651202.svg";
export { ForwardRef as ReactComponent };